
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/joy-ui/api/radio-group",
      function () {
        return require("private-next-pages/joy-ui/api/radio-group.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/joy-ui/api/radio-group"])
      });
    }
  